import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { Text, Space, Spin } from "react_reusable_components";
import { ThreeRow, TwoColumn, TwoRow } from "../../core/layouts";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import variables from "../../themes/base/styles/variables";
import { NotificationsContext } from "../../globalContext/notifications/notificationsProvider";
import moment from "moment";

const notificationsPopUpStyle = {
  notificationHeaderText: {
    fontSize: variables.fontSizeNormal,
    lineHeight: variables.lineHeightSmall,
    fontWeight: variables.fontWeightBold,
  },
  crossIcon: {
    width: variables.iconWidthLarge,
    height: variables.iconHeightLarge,
    cursor: "pointer",
  },
  twoColumnStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.spaceBetween,
  },
  seeAllNotificationsTextStyle: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    textAlign: "center",
    color: variables.primaryBg,
    cursor: "pointer",
  },
  notifcationRowStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.spaceBetween,
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    borderBottom: `1px solid ${variables.grey5}`,
    cursor: "pointer",
    gap: variables.gapSmaller,
  },
  notificationTitleStyle: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "12rem",
  },
  notificationTimeStampStyle: {
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightNormal,
    color: variables.grey2,
    width: "10rem",
    textAlign: "end",
  },
  topSectionStyle: {
    padding: variables.paddingSmall,
    display: variables.dFlex,
    justifyContent: variables.spaceBetween,
  },
  seeAllNotificationsContainerStyle: {
    display: variables.dFlex,
    justifyContent: variables.alignCenter,
    padding: `${variables.paddingSmaller} ${variables.paddingSmall}`,
    borderBottom: `1px solid ${variables.grey5}`,
  },
  notificationRowLeftColumnStyle: {
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    gap: variables.gapXS,
  },
  dividerStyle: {
    margin: "0rem",
    color: variables.grey5,
  },
  emptyNotification: {
    color: "rgb(180, 180, 180)",
    textAlign: variables.alignCenter,
    padding: variables.paddingMedium,
    height: "18rem",
    display: variables.dFlex,
    alignItems: variables.alignCenter,
    justifyContent: variables.alignCenter,
  },
};

export default function MyNotificationsPopUpContent({ handleOpenChange }) {
  const navigate = useNavigate();
  const intl = useIntl();
  const [notificationState] = useContext(NotificationsContext);

  const particularNotificationHandler = (notification) => {
    handleOpenChange();
    navigate("/notifications");
  };

  const seeAllNotificationsHandler = async () => {
    navigate("/notifications");
    handleOpenChange();
  };

  const notificationsData = notificationState.notificationsList || [];

  return (
    <ThreeRow
      style={{
        width: variables.notificationsBoxWidth,
      }}
      topSectionStyle={notificationsPopUpStyle.topSectionStyle}
      topSection={
        <TwoColumn
          style={notificationsPopUpStyle.twoColumnStyle}
          leftSection={
            <Text
              style={notificationsPopUpStyle?.notificationHeaderText}
              type="secondary"
            >
              {getLocalizedMessage(
                intl,
                "notifications.heading.myNotifications"
              )}
            </Text>
          }
          rightSection={
            <img
              style={notificationsPopUpStyle.crossIcon}
              src={"/icons/close.svg"}
              alt="notifications-close"
              onClick={() => handleOpenChange()}
            />
          }
        />
      }
      middleSection={
        <Space
          size={0}
          direction="vertical"
          style={{ width: variables.fullWidth }}
        >
          {notificationsData?.length < 1 && (
            <div style={notificationsPopUpStyle.emptyNotification}>
              {notificationState.loading ? (
                <Spin type="default" />
              ) : (
                getLocalizedMessage(intl, "navbar.noNotification")
              )}
            </div>
          )}
          {notificationsData?.slice?.(0, 5)?.map((notification) => (
            <TwoColumn
              key={notification}
              style={{
                ...notificationsPopUpStyle.notifcationRowStyle,
              }}
              onClick={() => particularNotificationHandler(notification)}
              leftSectionStyle={{ flex: 1 }}
              leftSection={
                <TwoColumn
                  style={notificationsPopUpStyle.notificationRowLeftColumnStyle}
                  leftSection={
                    <img src={"/icons/polygon_red.svg"} alt={"Status"} />
                  }
                  rightSectionStyle={{ flex: 1 }}
                  rightSection={
                    <Text
                      style={notificationsPopUpStyle.notificationTitleStyle}
                      type="secondary"
                    >
                      {notification?.message}
                    </Text>
                  }
                />
              }
              rightSection={
                <Text
                  style={notificationsPopUpStyle.notificationTimeStampStyle}
                >
                  {moment(notification?.created_at).format(
                    "hh:mm A, MM/DD/YYYY"
                  )}
                </Text>
              }
            />
          ))}
        </Space>
      }
      bottomSection={
        !!notificationsData?.length && (
          <TwoRow
            topSectionStyle={
              notificationsPopUpStyle.seeAllNotificationsContainerStyle
            }
            topSection={
              <Text
                style={notificationsPopUpStyle?.seeAllNotificationsTextStyle}
                onClick={() => seeAllNotificationsHandler()}
              >
                {getLocalizedMessage(intl, "notifications.text.seeAll")}
              </Text>
            }
            bottomSectionStyle={{ height: "2rem" }}
          />
        )
      }
    />
  );
}
